import { CLEAR_DEVICE } from '../DeviceSelector/constants'
import {
  UPDATE_PHONE_ID,
  UPDATE_PRESALE_FLAG,
  SWAP_LANGUAGE,
  FETCH_CUSTOMER,
  FETCH_OPTIONS
} from './constants'

const initialState = {
  preSaleFlag: false,
  currentPhoneId: null,
  currentPhoneName: 'No Device Selected',
  language: 'en',
  customer: null,
}

export default function devicebits(state = initialState, action) {
  switch (action.type) {
    case UPDATE_PHONE_ID: {
      return {
        ...state,
        currentPhoneId: action.phoneId,
        currentPhoneName: action.deviceName
      }
    }
    case UPDATE_PRESALE_FLAG: {
      return {
        ...state,
        preSaleFlag: true
      }
    }
    case FETCH_CUSTOMER['SUCCESS']: {
      return {
        ...state,
        customer: action.customer
      }
    }
    case SWAP_LANGUAGE: {
      return {
        ...state,
        language: action.language
      }
    }
    case CLEAR_DEVICE: {
      return {
        ...state,
        currentPhoneId: initialState.currentPhoneId,
        currentPhoneName: initialState.currentPhoneName
      }
    }
    case FETCH_OPTIONS['SUCCESS']: {
      return {
        ...state,
        options: action.options
      }
    }
    default: {
      return state
    }
  }
}



// WEBPACK FOOTER //
// ./src/containers/App/reducer.js